import React from 'react';
import { Form } from '@/components/ui';
import { HE_INTERNAL_COMMENT_MAX_LENGTH } from '../utils/internalComment';

interface HiredEquipmentInternalCommentProps {
  value: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const HiredEquipmentInternalComment: React.FC<HiredEquipmentInternalCommentProps> = ({
  value,
  onChange,
  disabled = false,
  className = '',
}) => {
  const isEditable = Boolean(onChange) && !disabled;
  if (!isEditable && !value.trim()) return null;

  return (
    <section
      className={`tw-rounded-lg tw-border tw-border-line-input tw-bg-surface tw-p-4 tw-shadow-sm ${className}`}
    >
      <Form.Group controlId="hired-equipment-internal-comment" className="tw-mb-0">
        <Form.Label>Internal comment</Form.Label>
        {isEditable ? (
          <>
            <Form.Control
              as="textarea"
              rows={3}
              maxLength={HE_INTERNAL_COMMENT_MAX_LENGTH}
              value={value}
              placeholder="Add a note for internal staff…"
              onChange={(event) => onChange?.(event.currentTarget.value)}
            />
            <Form.Text>
              Internal only — this comment is not included in emails or PDFs. {value.length}/
              {HE_INTERNAL_COMMENT_MAX_LENGTH}
            </Form.Text>
          </>
        ) : (
          <>
            <p className="tw-mb-0 tw-whitespace-pre-wrap tw-break-words tw-text-content">{value}</p>
            <Form.Text>Internal only — not included in emails or PDFs.</Form.Text>
          </>
        )}
      </Form.Group>
    </section>
  );
};

export default HiredEquipmentInternalComment;
